import { render, staticRenderFns } from "./MenuAdmin.vue?vue&type=template&id=708e8a80&scoped=true&"
import script from "./MenuAdmin.vue?vue&type=script&lang=js&"
export * from "./MenuAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MenuAdmin.vue?vue&type=style&index=0&id=708e8a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708e8a80",
  null
  
)

export default component.exports